export const getJustifyContent = (logo, flag) => {
    if (logo && flag) {
        return 'space-between';
    }
    if (flag) {
        return 'flex-end';
    }
    return 'flex-start';
};
